import dateFormat from 'dateformat';
import { getDateTimeFormat } from '#helper';

const reduceCallback = (acc, item, index, self) => {
  if (!acc.date && index > 0 && index < self.length - 1 && item.date) {
    acc.date = new Date(item.date);
    acc.index = index;
  }
  return acc;
};

export default (values, props) => {
  const { account, shipment: { states } = {} } = props;
  const dateTimeFormat = getDateTimeFormat(account && account.measurementSystem);
  const errors = {};
  const MAX_CUSTOM_FIELDS_LENGTH = 100;

  if (values.label?.length > 255) {
    errors.label = 'Max 255 characters';
  }

  if (!values.project) {
    errors.project = 'Required';
  }

  if (!values.beginDate) {
    errors.beginDate = 'Required';
  } else if (values.beginDate instanceof Date && Number.isNaN(values.beginDate.valueOf())) {
    errors.beginDate = 'Invalid date';
  }

  if (values.endDate) {
    const { beginDate, endDate } = values;
    if (values.endDate instanceof Date && Number.isNaN(values.endDate.valueOf())) {
      errors.endDate = 'Invalid date';
    } else if (beginDate > endDate) {
      errors.endDate =
        `Must be later than ${dateFormat(beginDate, dateTimeFormat)}`;
    }
  }

  if (states && states.length > 2) {
    const nextStateWithDate = states.reduce(reduceCallback, { date: null, index: null });
    const previousStateWithDate = states.reduceRight(reduceCallback, { date: null, index: null });

    const { beginDate, endDate } = values;
    if (nextStateWithDate.date && beginDate > nextStateWithDate.date) {
      errors.beginDate =
      `Must be earlier than delivery state #${nextStateWithDate.index + 1} date: ${dateFormat(nextStateWithDate.date, dateTimeFormat)}`;
    }
    if (endDate && previousStateWithDate.date &&
      endDate < previousStateWithDate.date) {
      errors.endDate = `Must be later than delivery state #${previousStateWithDate.index + 1} date: ${dateFormat(previousStateWithDate.date, dateTimeFormat)}`;
    }
  }

  if (values?.customFields?.length > MAX_CUSTOM_FIELDS_LENGTH) {
    errors.customFieldsContainer = { _error: `Error: Maximum ${MAX_CUSTOM_FIELDS_LENGTH} custom fields.` };
  }

  return errors;
};
